import React from 'react';
import styled from 'styled-components';
import FadeInUp from '../shared/Animation/FadeInUp';
import i18n from '../../config/i18n';

const H3 = styled.div`
  color: #748495;
  font-size: 42px;
  font-weight: 500;
  margin-bottom: 2em;
`;


const StyledWrap = styled.div`
  text-align: center;
  margin: 40px auto 80px;
`;

export default function () {
  return (
    <StyledWrap>
      <FadeInUp>
        <H3>
          {i18n.t('contact_us')}
        </H3>
        <a href="mailto:connect@ihealthcareclouds.com" target="_top" className="btn boca-btn">
          {i18n.t('send_mail')}
        </a>
      </FadeInUp>
    </StyledWrap>
  );
}



// WEBPACK FOOTER //
// ./src/components/landing/ContactUs.js